import { RouteConfig } from "vue-router"

export const userRoutes: RouteConfig[] = [
    {
        path: "user",
        component: () => import("@/layouts/Wrapper.vue"),
        meta: { title: "User" },
        redirect: "user/settings",
        children: [
            {
                path: "settings",
                name: "UserSettings",
                component: () => import("@/views/user/Profile.vue"),
                meta: { title: "Settings", isContextSource: true },
            },
            {
                path: "profile",
                component: () => import("@/layouts/Wrapper.vue"),
                meta: { doNotVisit: true, doNotShow: true },
                children: [
                    {
                        path: "privacy",
                        name: "UserPrivacy",
                        component: () => import("@/views/user/Privacy.vue"),
                        meta: { title: "Privacy" },
                    },
                ],
            },
            {
                path: "info",
                name: "UserInfo",
                component: () => import("@/views/user/Account.vue"),
                meta: { title: "Personal Information" },
            },
            {
                path: "change-password",
                name: "ChangePassword",
                component: () => import("@/views/user/ChangePassword.vue"),
                meta: { title: "Change Password" },
            },
            {
                path: "alarm-notifications",
                name: "UserAlarmNotifications",
                component: () => import("@/views/user/AlarmNotifications.vue"),
                meta: { title: "Alarm notifications" },
            },
            {
                path: "two-factor-authentication",
                name: "UserTwoFactorAuth",
                component: () => import("@/views/user/TwoFactorAuth.vue"),
                meta: { title: "Two-factor authentication" },
            },
        ],
    },
]
